import gql from "graphql-tag";

export const GET_POSTS = gql`
    query GetPosts($first: Int!, $after: String) {
        posts (first: $first, after:$after){
            edges{
                node{
                    id
                    subject
                    category
                    message
                    created
                    imagesUrls
                    documentsUrls
                    author{
                        id
                        username
                        profile{
                            id
                            displayName
                        }
                    }
                    commentSet{
                        edges{
                            node{
                                id
                            }
                        }
                    }
                    tagSet{
                        edges{
                            node{
                                id
                                name
                            }
                        }
                    }
                }
            }
            pageInfo{
                endCursor
                hasNextPage
            }
        }
    }
`;
